import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgWarningAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.9978 13.5835C15.0208 13.3608 14.8652 13.0894 14.5541 12.5467L8.9444 2.76215C8.63437 2.22139 8.47935 1.951 8.27711 1.86019C8.1007 1.78098 7.8993 1.78098 7.72289 1.86019C7.52065 1.951 7.36563 2.22139 7.0556 2.76215L1.44595 12.5467C1.1348 13.0894 0.979233 13.3608 1.00223 13.5835C1.02228 13.7777 1.12307 13.9542 1.2795 14.0691C1.45884 14.2008 1.76935 14.2008 2.39035 14.2008H13.6096C14.2307 14.2008 14.5412 14.2008 14.7205 14.0691C14.8769 13.9542 14.9777 13.7777 14.9978 13.5835ZM2.57162 12.9975H13.4284L8 3.52918L2.57162 12.9975Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8.69386 6.52394C8.69386 6.13483 8.38276 5.8194 7.99901 5.8194C7.61525 5.8194 7.30415 6.13483 7.30415 6.52394V9.09162C7.30415 9.48073 7.61525 9.79616 7.99901 9.79616C8.38276 9.79616 8.69386 9.48073 8.69386 9.09162V6.52394Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.99899 12.2197C8.40833 12.2197 8.74017 11.8832 8.74017 11.4682C8.74017 11.0531 8.40833 10.7166 7.99899 10.7166C7.58965 10.7166 7.25781 11.0531 7.25781 11.4682C7.25781 11.8832 7.58965 12.2197 7.99899 12.2197Z" })
	]
});
export default SvgWarningAlt;
